<template>
  <v-app>
    <v-row class="row-404">
      <v-col class="col-404">
        <p>404 | Not found</p>
        <v-btn @click="back">Back</v-btn>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
// import image404 from "@/assets/image404.png";
export default {
  name: "err404",
  data() {
    return {
      href:
        "https://accounts.google.com/signin/oauth/oauthchooseaccount?client_id=468159205827-175bdm4ks3m813i1qnigcn12ghbmmrq4.apps.googleusercontent.com&redirect_uri=https%3A%2F%2Fsun-cms-api.auth.us-east-2.amazoncognito.com%2Foauth2%2Fidpresponse&scope=profile%20email%20openid&response_type=code&state=ZXlKMWMyVnlVRzl2YkVsa0lqb2lkWE10WldGemRDMHlYM1ZTUTBoUVIyeEJieUlzSW5CeWIzWnBaR1Z5VG1GdFpTSTZJa2R2YjJkc1pTSXNJbU5zYVdWdWRFbGtJam9pTkRKa05tSTBhV2xsWnpWMk16QTBjR3N6ZEd0bGNHaG1iMlVpTENKeVpXUnBjbVZqZEZWU1NTSTZJbWgwZEhBNkx5OXNiMk5oYkdodmMzUTZPREE0TUNJc0luSmxjM0J2Ym5ObFZIbHdaU0k2SW5SdmEyVnVJaXdpY0hKdmRtbGtaWEpVZVhCbElqb2lSMjl2WjJ4bElpd2ljMk52Y0dWeklqcGJJbTl3Wlc1cFpDSXNJbVZ0WVdsc0lsMHNJbk4wWVhSbElqb2lkblJGU0c4MmMwRmlWekJTT0VKV1ZGb3lNbVJsY1Rka2VHMWpXRW8zWW1jaUxDSmpiMlJsUTJoaGJHeGxibWRsSWpwdWRXeHNMQ0pqYjJSbFEyaGhiR3hsYm1kbFRXVjBhRzlrSWpwdWRXeHNMQ0p1YjI1alpTSTZJbUYxTW1FMlNYSkVRVVJQWmpWT2RHVnVjbXQwZFZsTFowdG9Ubmd5VEhwNkxVWnlNak15UjNreE1sVTFOVVkwUkdoS2IyUnhTMVV6ZVdaM1FURXRVVzVQWlRWdU1FRlhWRTVoYVVKTGFqQjJTWGxKYkVKR1ptRXpaV2cyYmxreWFYbEJhMnBpTlhZdFpscElSbGRvV0ZjM1UzRjFlVkZhVG14UVJDMTJUbkpsU21OMVVITnNTbmg1TkhwT2JTMW9PRkZtTTNSRVZFNU1TbW90YkZGVWVtRlJWbEV4WHpCUlIwOTVXU0lzSW5ObGNuWmxja2h2YzNSUWIzSjBJam9pYzNWdUxXTnRjeTFoY0drdVlYVjBhQzUxY3kxbFlYTjBMVEl1WVcxaGVtOXVZMjluYm1sMGJ5NWpiMjBpTENKamNtVmhkR2x2YmxScGJXVlRaV052Ym1Seklqb3hOVGt3TkRneU16WTBMQ0p6WlhOemFXOXVJanB1ZFd4c0xDSjFjMlZ5UVhSMGNtbGlkWFJsY3lJNmJuVnNiQ3dpYVhOVGRHRjBaVVp2Y2t4cGJtdHBibWRUWlhOemFXOXVJanBtWVd4elpYMD06aC9ZaW1lOG9EMkJzcHhYelFSdWFjdUtnc2tSem93blVCVmlhZ2xCYWwxUT06Mg%3D%3D&o2v=2&as=06Wxx3C4_8DcXJLfBy9L-w&flowName=GeneralOAuthFlow"
      // img: image404
    };
  },
  methods: {
    back() {
      // console.log("windowL ", window.location);
      // window.location.href = this.href;
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./_err404Style.scss";
</style>